<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
body, html {
  padding: 0;
  margin: 0;
  width: 100%;
  min-height: 100vh;
}
#app {
  font-family: Metric, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #fff;

  --tw-bg-opacity: 1;
  background-color: rgb(17 9 24 / var(--tw-bg-opacity));
  background-image: url(//slotmatrix.com/wp-content/themes/slotmatrix/assets/img/hero-home.png);
  background-position: top;
  background-repeat: no-repeat;
  background-size: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue